var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brands / apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4402 5.19C15.8182 4.75428 16.1065 4.24817 16.2884 3.70074C16.4703 3.1533 16.5422 2.57533 16.5002 2C15.3395 2.09369 14.2622 2.63956 13.5002 3.52C13.1353 3.94198 12.8587 4.43288 12.687 4.96364C12.5152 5.49441 12.4517 6.05424 12.5002 6.61C13.0663 6.61472 13.6259 6.4891 14.1358 6.24286C14.6456 5.99662 15.0919 5.63637 15.4402 5.19ZM17.9602 12.63C17.9669 11.8637 18.1687 11.1118 18.5466 10.4452C18.9245 9.77859 19.4661 9.21926 20.1202 8.82C19.7074 8.22524 19.1617 7.73483 18.5264 7.38767C17.8911 7.04052 17.1836 6.84615 16.4602 6.82C14.9002 6.66 13.4602 7.73 12.6302 7.73C11.8002 7.73 10.6302 6.84 9.33016 6.86C8.48028 6.888 7.65218 7.13578 6.9266 7.57919C6.20103 8.02259 5.60276 8.64648 5.19016 9.39C3.43016 12.45 4.74016 17 6.50016 19.47C7.30016 20.68 8.30016 22.05 9.62016 22C10.9402 21.95 11.3702 21.18 12.9002 21.18C14.4302 21.18 14.9002 22 16.2002 21.97C17.5002 21.94 18.4202 20.73 19.2602 19.52C19.8552 18.6415 20.32 17.6816 20.6402 16.67C19.8476 16.332 19.1715 15.7693 18.6952 15.0513C18.2189 14.3333 17.9634 13.4916 17.9602 12.63Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a31a2d9de44d285733a4494c5f0dfc9f.svg";
export { ForwardRef as ReactComponent };